import { BadgeWebElementBase } from './BadgeWebElementBase';

/**
 * The component WebElement for [oj-c-badge](../../../oj-c/docs/oj.Badge.html).
 * Do not instantiate this class directly, instead, use
 * [findBadge](../functions/findBadge.html).
 */
export class BadgeWebElement extends BadgeWebElementBase {
  // Put overrides here
}
